export const LOADING: unique symbol = Symbol('LOADING');
export type Loading = typeof LOADING;

export type LoadState<T> = Loading | T;

export const isLoading = (value: unknown): value is Loading =>
  value === LOADING;

export const isLoaded = <T>(value: LoadState<T>): value is T =>
  !isLoading(value);
